(ns app.front.view.admin.migration.link-acceptances-to-sub-reviews
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(def task-id :app.admin.migration.task/link-acceptances-to-sub-reviews)

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   task-id
    :title     "Link review acceptances to sub-reviews"
    :help-text (str "Links existing item-level review comments to the review round they most likely belong to, "
                    "based on acceptance and review round creation times.")}
   match])

(def route
  {:name        :view/admin.migration.link-acceptances-to-sub-reviews
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks task-id]))}]})
